// import { useState } from "react";
// import {
//     Search,
//     FileText,
//     ArrowRight,
//     X,
//     Clock,
//     ShieldCheck,
//     Calculator,
//     Pencil,
//     Trash2,
// } from "lucide-react";

// const STATUS_STYLES = {
//     "Quotation Selected": "bg-emerald-50 text-emerald-600",
//     "Under Evaluation": "bg-amber-50 text-amber-600",
//     "Awaiting Quotation": "bg-blue-50 text-blue-600",
// };

// const INITIAL_ENQUIRIES = [
//     {
//         id: "APIC-ENQ-00123",
//         name: "Smart IoT Water Sensor",
//         category: "IoT / PCB",
//         budgetMin: 100000,
//         budgetMax: 200000,
//         target: "2026-08-30",
//         quotations: 5,
//         status: "Quotation Selected",
//     },
//     {
//         id: "APIC-ENQ-00124",
//         name: "Industrial Fixture Assembly",
//         category: "Industrial",
//         budgetMin: 50000,
//         budgetMax: 80000,
//         target: "2026-08-15",
//         quotations: 3,
//         status: "Under Evaluation",
//     },
//     {
//         id: "APIC-ENQ-00125",
//         name: "Custom Enclosure Batch",
//         category: "3D Printing",
//         budgetMin: 30000,
//         budgetMax: 60000,
//         target: "2026-09-05",
//         quotations: 2,
//         status: "Awaiting Quotation",
//     },
// ];

// const EMPTY_QUOTE = {
//     material: "",
//     manufacturing: "",
//     tooling: "",
//     otherCharges: "",
//     gstPercent: "18",
//     deliveryDays: "",
//     notes: "",
// };

// const formatINR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

// export default function Enquiries() {
//     const [enquiries] = useState(INITIAL_ENQUIRIES);
//     const [submittedQuotes, setSubmittedQuotes] = useState([]);
//     const [search, setSearch] = useState("");
//     const [activeEnquiry, setActiveEnquiry] = useState(null);
//     const [editingQuoteId, setEditingQuoteId] = useState(null);
//     const [quote, setQuote] = useState(EMPTY_QUOTE);

//     const filtered = enquiries.filter((e) => {
//         if (!search.trim()) return true;
//         const q = search.toLowerCase();
//         return (
//             e.id.toLowerCase().includes(q) ||
//             e.name.toLowerCase().includes(q) ||
//             e.category.toLowerCase().includes(q)
//         );
//     });

//     const stats = [
//         { label: "Open Enquiries", value: enquiries.filter((e) => e.status === "Awaiting Quotation").length },
//         { label: "Quotations Received", value: enquiries.reduce((sum, e) => sum + e.quotations, 0) },
//         { label: "Under Evaluation", value: enquiries.filter((e) => e.status === "Under Evaluation").length },
//         { label: "Selected", value: enquiries.filter((e) => e.status === "Quotation Selected").length },
//         { label: "My Quotations Sent", value: submittedQuotes.length },
//     ];

//     const openQuoteModal = (enquiry) => {
//         setActiveEnquiry(enquiry);
//         setEditingQuoteId(null);
//         setQuote(EMPTY_QUOTE);
//     };

//     const openEditQuoteModal = (submittedQuote) => {
//         const enquiry = enquiries.find((e) => e.id === submittedQuote.enquiryId);
//         setActiveEnquiry(enquiry);
//         setEditingQuoteId(submittedQuote.quoteId);
//         setQuote({
//             material: String(submittedQuote.material),
//             manufacturing: String(submittedQuote.manufacturing),
//             tooling: String(submittedQuote.tooling),
//             otherCharges: String(submittedQuote.otherCharges),
//             gstPercent: String(submittedQuote.gstPercent),
//             deliveryDays: String(submittedQuote.deliveryDays),
//             notes: submittedQuote.notes,
//         });
//     };

//     const closeModal = () => {
//         setActiveEnquiry(null);
//         setEditingQuoteId(null);
//         setQuote(EMPTY_QUOTE);
//     };

//     const handleQuoteChange = (field, value) => {
//         setQuote((prev) => ({ ...prev, [field]: value }));
//     };

//     const subtotal =
//         Number(quote.material || 0) + Number(quote.manufacturing || 0) + Number(quote.tooling || 0) + Number(quote.otherCharges || 0);
//     const gstAmount = (subtotal * Number(quote.gstPercent || 0)) / 100;
//     const total = subtotal + gstAmount;

//     const handleSubmitQuote = (e) => {
//         e.preventDefault();
//         if (!quote.material || !quote.manufacturing || !quote.deliveryDays) return;

//         if (editingQuoteId) {
//             setSubmittedQuotes((prev) =>
//                 prev.map((row) =>
//                     row.quoteId === editingQuoteId
//                         ? {
//                             ...row,
//                             material: Number(quote.material),
//                             manufacturing: Number(quote.manufacturing),
//                             tooling: Number(quote.tooling || 0),
//                             otherCharges: Number(quote.otherCharges || 0),
//                             gstPercent: Number(quote.gstPercent),
//                             deliveryDays: Number(quote.deliveryDays),
//                             notes: quote.notes,
//                             total,
//                         }
//                         : row
//                 )
//             );
//         } else {
//             const newRow = {
//                 quoteId: `Q-${Date.now()}`,
//                 enquiryId: activeEnquiry.id,
//                 enquiryName: activeEnquiry.name,
//                 category: activeEnquiry.category,
//                 material: Number(quote.material),
//                 manufacturing: Number(quote.manufacturing),
//                 tooling: Number(quote.tooling || 0),
//                 otherCharges: Number(quote.otherCharges || 0),
//                 gstPercent: Number(quote.gstPercent),
//                 deliveryDays: Number(quote.deliveryDays),
//                 notes: quote.notes,
//                 total,
//                 submittedOn: new Date().toISOString().slice(0, 10),
//                 status: "Submitted",
//             };
//             setSubmittedQuotes((prev) => [newRow, ...prev]);
//         }

//         closeModal();
//     };

//     const handleDeleteQuote = (quoteId) => {
//         setSubmittedQuotes((prev) => prev.filter((row) => row.quoteId !== quoteId));
//     };

//     return (
//         <div className="h-full overflow-y-auto bg-gray-50 p-8">
//             {/* Stat cards */}
//             <div className="mb-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
//                 {stats.map((s) => (
//                     <div key={s.label} className="rounded-2xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
//                         <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400">
//                             {s.label}
//                         </p>
//                         <p className="mt-2 text-2xl font-bold text-gray-900">{s.value}</p>
//                     </div>
//                 ))}
//             </div>

//             {/* Search */}
//             <div className="mb-4">
//                 <div className="relative max-w-md">
//                     <Search size={18} className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
//                     <input
//                         type="text"
//                         value={search}
//                         onChange={(e) => setSearch(e.target.value)}
//                         placeholder="Search by enquiry ID, name, category..."
//                         className="w-full rounded-full border border-gray-200 bg-white py-3 pl-11 pr-4 text-sm text-gray-700 shadow-sm outline-none placeholder:text-gray-400 focus:border-blue-400"
//                     />
//                 </div>
//             </div>

//             {/* Enquiries table */}
//             <div className="mb-8 overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
//                 <div className="border-b border-gray-100 px-6 py-4">
//                     <h2 className="text-sm font-bold text-gray-900">Open Enquiries</h2>
//                 </div>
//                 <table className="w-full text-left">
//                     <thead>
//                         <tr className="border-b border-gray-100 bg-gray-50/60 text-xs font-semibold uppercase tracking-wider text-gray-400">
//                             <th className="px-6 py-4">Enquiry</th>
//                             <th className="px-6 py-4">Category</th>
//                             <th className="px-6 py-4">Budget</th>
//                             <th className="px-6 py-4">Target</th>
//                             <th className="px-6 py-4">Quotations</th>
//                             <th className="px-6 py-4">Status</th>
//                             <th className="px-6 py-4 text-right">Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {filtered.map((enquiry) => (
//                             <tr key={enquiry.id} className="border-b border-gray-50 last:border-0 hover:bg-gray-50/50">
//                                 <td className="px-6 py-4">
//                                     <p className="text-sm font-semibold text-gray-900">{enquiry.name}</p>
//                                     <p className="text-xs text-gray-400">{enquiry.id}</p>
//                                 </td>
//                                 <td className="px-6 py-4 text-sm text-gray-600">{enquiry.category}</td>
//                                 <td className="px-6 py-4 text-sm text-gray-600">
//                                     {formatINR(enquiry.budgetMin)} – {formatINR(enquiry.budgetMax)}
//                                 </td>
//                                 <td className="px-6 py-4 text-sm text-gray-600">{enquiry.target}</td>
//                                 <td className="px-6 py-4">
//                                     <span className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-600">
//                                         <FileText size={16} />
//                                         {enquiry.quotations}
//                                     </span>
//                                 </td>
//                                 <td className="px-6 py-4">
//                                     <span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${STATUS_STYLES[enquiry.status]}`}>
//                                         {enquiry.status}
//                                     </span>
//                                 </td>
//                                 <td className="px-6 py-4 text-right">
//                                     <button
//                                         onClick={() => openQuoteModal(enquiry)}
//                                         className="inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-indigo-600 to-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:opacity-90"
//                                     >
//                                         Send Quotation
//                                         <ArrowRight size={14} />
//                                     </button>
//                                 </td>
//                             </tr>
//                         ))}

//                         {filtered.length === 0 && (
//                             <tr>
//                                 <td colSpan={7} className="px-6 py-12 text-center text-sm text-gray-400">
//                                     No enquiries match your search.
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Submitted Quotations table */}
//             <div className="mb-8 overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
//                 <div className="border-b border-gray-100 px-6 py-4">
//                     <h2 className="text-sm font-bold text-gray-900">My Submitted Quotations</h2>
//                 </div>
//                 <table className="w-full text-left">
//                     <thead>
//                         <tr className="border-b border-gray-100 bg-gray-50/60 text-xs font-semibold uppercase tracking-wider text-gray-400">
//                             <th className="px-6 py-4">Enquiry</th>
//                             <th className="px-6 py-4 text-right">Material</th>
//                             <th className="px-6 py-4 text-right">Manufacturing</th>
//                             <th className="px-6 py-4 text-right">Tooling</th>
//                             <th className="px-6 py-4 text-right">Other</th>
//                             <th className="px-6 py-4 text-right">GST</th>
//                             <th className="px-6 py-4 text-right">Total</th>
//                             <th className="px-6 py-4">Delivery</th>
//                             <th className="px-6 py-4">Submitted On</th>
//                             <th className="px-6 py-4 text-right">Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {submittedQuotes.map((row) => (
//                             <tr key={row.quoteId} className="border-b border-gray-50 last:border-0 hover:bg-gray-50/50">
//                                 <td className="px-6 py-4">
//                                     <p className="text-sm font-semibold text-gray-900">{row.enquiryName}</p>
//                                     <p className="text-xs text-gray-400">{row.enquiryId}</p>
//                                 </td>
//                                 <td className="px-6 py-4 text-right text-sm text-gray-600">{formatINR(row.material)}</td>
//                                 <td className="px-6 py-4 text-right text-sm text-gray-600">{formatINR(row.manufacturing)}</td>
//                                 <td className="px-6 py-4 text-right text-sm text-gray-600">{formatINR(row.tooling)}</td>
//                                 <td className="px-6 py-4 text-right text-sm text-gray-600">{formatINR(row.otherCharges)}</td>
//                                 <td className="px-6 py-4 text-right text-sm text-gray-600">{row.gstPercent}%</td>
//                                 <td className="px-6 py-4 text-right text-sm font-bold text-blue-600">{formatINR(row.total)}</td>
//                                 <td className="px-6 py-4 text-sm text-gray-600">{row.deliveryDays} days</td>
//                                 <td className="px-6 py-4 text-sm text-gray-600">{row.submittedOn}</td>
//                                 <td className="px-6 py-4">
//                                     <div className="flex items-center justify-end gap-3">
//                                         <button
//                                             onClick={() => openEditQuoteModal(row)}
//                                             className="text-gray-400 transition hover:text-gray-700"
//                                             aria-label="Edit quotation"
//                                         >
//                                             <Pencil size={16} />
//                                         </button>
//                                         <button
//                                             onClick={() => handleDeleteQuote(row.quoteId)}
//                                             className="text-pink-400 transition hover:text-pink-600"
//                                             aria-label="Delete quotation"
//                                         >
//                                             <Trash2 size={16} />
//                                         </button>
//                                     </div>
//                                 </td>
//                             </tr>
//                         ))}

//                         {submittedQuotes.length === 0 && (
//                             <tr>
//                                 <td colSpan={10} className="px-6 py-12 text-center text-sm text-gray-400">
//                                     No quotations submitted yet. Click "Send Quotation" on an enquiry above.
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Info cards */}
//             <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
//                 <InfoCard
//                     icon={<FileText size={18} />}
//                     title="Fair comparison"
//                     description="See material, manufacturing, tooling and GST breakdown side-by-side."
//                 />
//                 <InfoCard
//                     icon={<Clock size={18} />}
//                     title="Faster procurement"
//                     description="Multiple Centres respond in parallel — no back-and-forth phone calls."
//                 />
//                 <InfoCard
//                     icon={<ShieldCheck size={18} />}
//                     title="Verified Centres"
//                     description="Every APIC Centre and eligible Vendor is admin-approved."
//                 />
//             </div>

//             {/* Quotation Modal */}
//             {activeEnquiry && (
//                 <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={closeModal}>
//                     <div className="max-h-[90vh] w-full max-w-xl overflow-hidden rounded-2xl bg-white shadow-xl" onClick={(e) => e.stopPropagation()}>
//                         <div className="flex items-start justify-between border-b border-gray-100 px-6 py-5">
//                             <div>
//                                 <h2 className="text-lg font-bold text-gray-900">
//                                     {editingQuoteId ? "Edit Quotation" : "Send Price Quotation"}
//                                 </h2>
//                                 <p className="mt-0.5 text-sm text-gray-500">
//                                     {activeEnquiry.name} · {activeEnquiry.id}
//                                 </p>
//                             </div>
//                             <button onClick={closeModal} className="text-gray-400 transition hover:text-gray-700" aria-label="Close">
//                                 <X size={20} />
//                             </button>
//                         </div>

//                         <form onSubmit={handleSubmitQuote} className="max-h-[65vh] overflow-y-auto px-6 py-5">
//                             <div className="mb-4 flex items-center gap-2 rounded-xl bg-blue-50 px-4 py-3 text-xs text-blue-700">
//                                 <Calculator size={16} className="shrink-0" />
//                                 Budget range for this enquiry: {formatINR(activeEnquiry.budgetMin)} – {formatINR(activeEnquiry.budgetMax)}
//                             </div>

//                             <div className="grid grid-cols-2 gap-4">
//                                 <div>
//                                     <label className="mb-1.5 block text-xs font-semibold text-gray-500">Material Cost (₹)</label>
//                                     <input
//                                         type="number"
//                                         min="0"
//                                         required
//                                         value={quote.material}
//                                         onChange={(e) => handleQuoteChange("material", e.target.value)}
//                                         placeholder="e.g. 35000"
//                                         className="w-full rounded-xl border border-gray-200 px-3.5 py-2.5 text-sm text-gray-700 outline-none focus:border-blue-400"
//                                     />
//                                 </div>

//                                 <div>
//                                     <label className="mb-1.5 block text-xs font-semibold text-gray-500">Manufacturing Cost (₹)</label>
//                                     <input
//                                         type="number"
//                                         min="0"
//                                         required
//                                         value={quote.manufacturing}
//                                         onChange={(e) => handleQuoteChange("manufacturing", e.target.value)}
//                                         placeholder="e.g. 45000"
//                                         className="w-full rounded-xl border border-gray-200 px-3.5 py-2.5 text-sm text-gray-700 outline-none focus:border-blue-400"
//                                     />
//                                 </div>

//                                 <div>
//                                     <label className="mb-1.5 block text-xs font-semibold text-gray-500">Tooling Cost (₹)</label>
//                                     <input
//                                         type="number"
//                                         min="0"
//                                         value={quote.tooling}
//                                         onChange={(e) => handleQuoteChange("tooling", e.target.value)}
//                                         placeholder="e.g. 8000"
//                                         className="w-full rounded-xl border border-gray-200 px-3.5 py-2.5 text-sm text-gray-700 outline-none focus:border-blue-400"
//                                     />
//                                 </div>

//                                 <div>
//                                     <label className="mb-1.5 block text-xs font-semibold text-gray-500">Other Charges (₹)</label>
//                                     <input
//                                         type="number"
//                                         min="0"
//                                         value={quote.otherCharges}
//                                         onChange={(e) => handleQuoteChange("otherCharges", e.target.value)}
//                                         placeholder="e.g. 2000"
//                                         className="w-full rounded-xl border border-gray-200 px-3.5 py-2.5 text-sm text-gray-700 outline-none focus:border-blue-400"
//                                     />
//                                 </div>

//                                 <div>
//                                     <label className="mb-1.5 block text-xs font-semibold text-gray-500">GST (%)</label>
//                                     <select
//                                         value={quote.gstPercent}
//                                         onChange={(e) => handleQuoteChange("gstPercent", e.target.value)}
//                                         className="w-full rounded-xl border border-gray-200 px-3.5 py-2.5 text-sm text-gray-700 outline-none focus:border-blue-400"
//                                     >
//                                         <option value="0">0%</option>
//                                         <option value="5">5%</option>
//                                         <option value="12">12%</option>
//                                         <option value="18">18%</option>
//                                         <option value="28">28%</option>
//                                     </select>
//                                 </div>

//                                 <div>
//                                     <label className="mb-1.5 block text-xs font-semibold text-gray-500">Delivery (days)</label>
//                                     <input
//                                         type="number"
//                                         min="1"
//                                         required
//                                         value={quote.deliveryDays}
//                                         onChange={(e) => handleQuoteChange("deliveryDays", e.target.value)}
//                                         placeholder="e.g. 21"
//                                         className="w-full rounded-xl border border-gray-200 px-3.5 py-2.5 text-sm text-gray-700 outline-none focus:border-blue-400"
//                                     />
//                                 </div>

//                                 <div className="col-span-2">
//                                     <label className="mb-1.5 block text-xs font-semibold text-gray-500">Notes (optional)</label>
//                                     <textarea
//                                         rows={3}
//                                         value={quote.notes}
//                                         onChange={(e) => handleQuoteChange("notes", e.target.value)}
//                                         placeholder="Payment terms, warranty, specifications..."
//                                         className="w-full resize-none rounded-xl border border-gray-200 px-3.5 py-2.5 text-sm text-gray-700 outline-none focus:border-blue-400"
//                                     />
//                                 </div>
//                             </div>

//                             {/* Live total */}
//                             <div className="mt-5 rounded-xl border border-gray-100 bg-gray-50 px-4 py-4">
//                                 <div className="flex justify-between text-sm text-gray-500">
//                                     <span>Subtotal</span>
//                                     <span>{formatINR(subtotal)}</span>
//                                 </div>
//                                 <div className="mt-1 flex justify-between text-sm text-gray-500">
//                                     <span>GST ({quote.gstPercent || 0}%)</span>
//                                     <span>{formatINR(gstAmount)}</span>
//                                 </div>
//                                 <div className="mt-2 flex justify-between border-t border-gray-200 pt-2 text-sm font-bold text-gray-900">
//                                     <span>Total Quotation</span>
//                                     <span className="text-blue-600">{formatINR(total)}</span>
//                                 </div>
//                             </div>

//                             <div className="mt-6 flex justify-end gap-3 border-t border-gray-100 pt-5">
//                                 <button
//                                     type="button"
//                                     onClick={closeModal}
//                                     className="rounded-full border border-gray-200 px-5 py-2.5 text-sm font-medium text-gray-600 transition hover:bg-gray-50"
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="rounded-full bg-gradient-to-r from-indigo-600 to-blue-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:opacity-90"
//                                 >
//                                     {editingQuoteId ? "Save Changes" : "Submit Quotation"}
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// function InfoCard({ icon, title, description }) {
//     return (
//         <div className="rounded-2xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
//             <div className="flex items-start gap-3">
//                 <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
//                     {icon}
//                 </div>
//                 <div>
//                     <p className="text-sm font-semibold text-gray-900">{title}</p>
//                     <p className="mt-0.5 text-sm text-gray-500">{description}</p>
//                 </div>
//             </div>
//         </div>
//     );
// }





import React, { useState } from "react";
import "../Users/components/modules/SalesManagment/SalesManagment.css";
import SalesManagmentall from "../Users/components/modules/SalesManagment/SalesManagmentall.jsx"
import Salsemannger from "../Users/components/modules/SalesManagment/Salsemannger.jsx";
// import LeadsOrders from "../Ordermanagment/Caterings/LeadsOrders.js";

/* ---------- Dummy Section Component ---------- */
const DummySection = ({ title }) => {
  return (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );
};

/* ---------- Main Company Component ---------- */
const Enquiries = () => {

  const tabs = [
    // { id: 8, name: "Leads Orders", component: () => <LeadsOrders title="LeadsOrders" /> },

    { id: 9, name: "Sales Executive", component: () => <SalesManagmentall title="Newdashbord" /> },
    { id: 7, name: "Manager", component: () => <Salsemannger title="Sourcing" /> },
  
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="company-container">

      {/* 🔹 Inline CSS */}
      <style>{`
        .company-scroll-container {
          position: static;
          background: #fff;
          overflow-x: auto;
        }

        .company-buttons-row {
          display: flex;
          flex-wrap: nowrap;
          gap: 8px;
        }

        .company-button {
          padding: 8px 16px;
          border: none;
          background: #f0f0f0;
          cursor: pointer;
          border-radius: 6px;
          white-space: nowrap;
          font-size: 14px;
        }

        .company-button.active {
          background: #4f46e5;
          color: #fff;
        }

        .dummy-box{
          padding:40px;
          text-align:center;
        }

        /* Desktop Sticky */
        @media (min-width: 769px) {
          .company-scroll-container {
            position: sticky;
            top: 0;
          }
        }
      `}</style>

      {/* Tabs */}
      <div className="company-scroll-container">
        <div className="company-buttons-row">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`company-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      {/* Active Section */}
      <div className="component-display">
        {ActiveComponent && <ActiveComponent />}
      </div>

    </div>
  );
};

export default Enquiries;


